export const reorderArray = function reorderArray<T>(
  array: Array<T>,
  srcIndex: number,
  dstIndex: number,
) {
  const items = array.slice();
  const srcItem = items[srcIndex]!;
  const dstItem = items[dstIndex]!;
  items.splice(srcIndex, 1);
  items.splice(dstIndex, 0, srcItem);

  return {
    oldItems: array,
    items,
    srcItem,
    dstItem,
  };
};
